// extracted by mini-css-extract-plugin
module.exports = {"post__footer":"Post-module--post__footer--3WzWU","post__comments":"Post-module--post__comments--25y6I","post__home-button":"Post-module--post__home-button--16Kl0"};